var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleQuestionmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m24 0c-13.2 0-24 10.8-24 24s10.8 24 24 24 24-10.9 24-24-10.8-24-24-24m0 45.9c-12 0-22-9.8-22-21.8s9.9-22 22-22 22 9.8 22 22-9.9 21.8-22 21.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m24.8 11c-2-0.2-3.9 0.4-5.4 1.7s-2.4 3.2-2.4 5.3h2c0-1.4 0.6-2.8 1.7-3.7s2.5-1.4 3.9-1.3c2.2 0.2 4.2 2.1 4.4 4.4 0.2 2-0.7 3.9-2.5 4.9-2.1 1.2-3.4 3.5-3.4 6.1v1.6h2v-1.6c0-1.8 1-3.4 2.5-4.4 2.5-1.4 3.8-4 3.5-6.8-0.5-3.2-3-5.7-6.3-6.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m24 33c-1.1 0-2 0.9-2 2s0.9 2 2 2 2-0.9 2-2c0-1.2-0.9-2-2-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestionmark);
export default __webpack_public_path__ + "static/media/circle-questionmark.e3e0911da71626c09b367c567974986d.svg";
export { ForwardRef as ReactComponent };